import { isString } from 'lodash';

export function formatUSD(amount) {
	if (!amount) {
		return '$0.00';
	}
	return parseFloat(isString(amount) ? amount.replace(/,/g, '') : amount)
	.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

export function formatNumber(value = 0) {
	const number = isString(value) ? parseFloat(value.replace(/,/g, '')) : value;
	return number.toLocaleString('en-US');
}

export function getNumericalValue(value = 0) {
	const number = isString(value) ? parseInt(value.replace(/,/g, ''), 10) : value;
	return number;
}

export function separateStringFirstSpace(str) {
	const stringSpaceIndex = str.indexOf(' ');
	const stringBeforeSpace = str.substring(0, stringSpaceIndex);
	const stringAfterSpace = str.substring(stringSpaceIndex + 1);
	return [stringBeforeSpace, stringAfterSpace];
}

export function getInitials(name) {
	const nameParts = name.split(' ');
	const firstNameInitial = nameParts[0] ? nameParts[0][0] : '';
	const lastNameInitial = nameParts[1] ? nameParts[1][0] : '';

	if (!firstNameInitial && !lastNameInitial) {
		return '';
	}

	if (name.length === 2) {
		return name.substring(0, 2).toUpperCase();
	}

	return (
		(firstNameInitial.toUpperCase() || '') +
		(lastNameInitial.toUpperCase() || '')
	);
}

// Utility to title-case a string (e.g., 'rv' -> 'RV', 'boat' -> 'Boat')
// Accepts an optional exceptions map for special casing (e.g., { rv: 'RV' })
export function toTitleCase(str, exceptions = { rv: 'RV' }) {
	if (!str) return '';
	return str
		.split(' ')
		.map((word) => {
			const lower = word.toLowerCase();
			if (exceptions[lower]) {
				return exceptions[lower];
			}
			return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
		})
		.join(' ');
}

export function formatSizeText(sizeText, fallback = sizeText) {
	try {
		const [w, h] = sizeText.split('x');
		return `${w}’ x ${h}’`;
	} catch (error) {
		console.error('Error formatting size text:', error);
		return fallback;
	}
}

// Pre-existing function moved here from app/store/selectors/search.js
// Relative paths get a leading slash so baseUrl + path is valid.
export const ensureAbsoluteUrl = (url, baseUrl) => {
	if (!url) return url;
	const path = url.startsWith('/') || url.startsWith('http') ? url : `/${url}`;
	const absoluteUrl = path.startsWith('http') ? path : `${baseUrl}${path}`;
	return absoluteUrl.includes('.html') ? absoluteUrl : `${absoluteUrl}.html`;
};
